import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Divider, Grid, Header, Icon, Segment } from "semantic-ui-react";
import {
  closeModal,
  openModal,
} from "../../../../app/common/modals/modalSlice";
import ModalWrapper from "../../../../app/common/modals/modalWrapper";
import DocFileUpload from "./DocFileUpload";
import { useMediaQuery } from "react-responsive";
import DocUrlUpload from "./DocUrlUpload";
import DocWebLinkUpload from "./DocWebLinkUpload";

export default function DocAddDocumentsModal() {
  const isMobile = useMediaQuery({ query: "(max-width:768px)" });
  const { currentUserProfile } = useSelector((state) => state.profile);
  const dispatch = useDispatch();

  function handleSelectForms() {
    dispatch(
      closeModal({
        modalType: "DocAddDocumentsModal",
      })
    );
    dispatch(
      openModal({
        modalType: "DocSelectFormsModal",
      })
    );
  }

  return (
    <>
      <ModalWrapper size="large">
        <Segment placeholder>
          {!currentUserProfile.state ||
          currentUserProfile.state === "Colorado" ? (
            <Grid stackable columns={14} textAlign="center">
              <Grid.Row verticalAlign="middle">

                <Grid.Column width={3}>
                  <DocFileUpload status={"In Progress"} />
                </Grid.Column>

                <Grid.Column width={1}>
                  <Header>OR</Header>
                </Grid.Column>

                <Grid.Column
                  width={2}
                  as={Link}
                  to="#"
                  onClick={() => handleSelectForms()}
                >
                  <Header icon color="grey">
                    <Icon name="file alternate outline" />
                    <br />
                    Select Forms
                  </Header>
                </Grid.Column>

                <Grid.Column width={1}>
                  <Header>OR</Header>
                </Grid.Column>
                
                <Grid.Column width={4}>
                  <DocWebLinkUpload />
                </Grid.Column>

                <Grid.Column width={1}>
                  <Header>OR</Header>
                </Grid.Column>
                
                <Grid.Column width={4}>
                  <DocUrlUpload />
                </Grid.Column>

              </Grid.Row>
            </Grid>
          ) : (
            <Grid stackable columns={2} textAlign="center">
              {!isMobile && <Divider vertical>Or</Divider>}
              <Grid.Row verticalAlign="middle">
                <Grid.Column>
                  <DocFileUpload status={"In Progress"} />
                </Grid.Column>

                <Grid.Column
                  as={Link}
                  to="#"
                  onClick={() => handleSelectForms()}
                >
                  <Header icon color="grey">
                    <Icon name="file alternate outline" />
                    <br />
                    Select Forms
                  </Header>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          )}
        </Segment>
      </ModalWrapper>
    </>
  );
}
